module.exports = __webpack_public_path__ + "img/TECNOLOGIA-ERTIGA-4.b303ffeb.jpg";